import ReactPixel from 'react-facebook-pixel';

const PIXEL_ID = 3120421894800622;

export const initFacebookPixel = () => {
    if (!PIXEL_ID) {
        console.warn('Facebook Pixel ID не найден в переменных окружения');
        return;
    }

    const options = {
        autoConfig: true
    };

    ReactPixel.init(PIXEL_ID, options);
    ReactPixel.pageView();

    console.log('Facebook Pixel инициализирован:', PIXEL_ID);
};

// Функции для отслеживания событий
export const fbPixel = {

    // Просмотр контента
    viewContent: (contentName, contentCategory = 'page') => {
        ReactPixel.track('ViewContent', {
            content_name: contentName,
            content_category: contentCategory,
        });
    },

    // Инициализация покупки
    initiateCheckout: (value, currency = 'KGS', contentName) => {
        ReactPixel.track('InitiateCheckout', {
            value: parseFloat(value),
            currency: currency,
            content_name: contentName,
        });
    },

    // Покупка
    purchase: (value, currency = 'KGS', contentName, orderId) => {
        ReactPixel.track('Purchase', {
            value: parseFloat(value),
            currency: currency,
            content_name: contentName,
            order_id: orderId,
        });
    },

    // Лид (заполнение формы)
    lead: (contentName) => {
        ReactPixel.track('Lead', {
            content_name: contentName,
        });
    },

    // Кастомное событие
    customEvent: (eventName, parameters = {}) => {
        ReactPixel.trackCustom(eventName, parameters);
    },
};

export default fbPixel;